export type Language = 'en' | 'ar';

export const translations = {
  en: {
    // Navigation
    nav_home: 'Home',
    nav_tasks: 'Tasks',
    nav_top: 'Top',
    nav_profile: 'Profile',

    // Home
    welcome: 'Welcome',
    welcome_desc: 'Complete tasks and earn rewards',
    available_tasks: 'Available Tasks',
    view_all: 'View all',
    wallet: 'Wallet',
    wallet_desc: 'Connect & Withdraw',
    leaderboard: 'Leaderboard',
    leaderboard_desc: 'Top Earners',

    // Stats
    balance: 'Balance',
    total_earned: 'Total Earned',
    completed: 'Completed',
    pending: 'Pending',
    reputation: 'Reputation',
    rank: 'Rank',
    tasks: 'tasks',
    reviews: 'reviews',

    // Tasks
    all: 'All',
    no_tasks_platform: 'No tasks available for this platform',
    slots_left: 'left',
    back: 'Back',
    claim_task: 'Claim Task',
    submit_proof: 'Submit Proof',
    open_task_link: 'Open Task Link',
    no_slots: 'No Slots Available',
    submission_status: 'Submission Status',

    // Task details
    platform: 'Platform',
    action: 'Action',
    slots_available: 'Slots Available',
    description: 'Description',
    instructions: 'Instructions',
    proof_required: 'Proof Required',
    deadline: 'Deadline',

    // Submit
    proof_url: 'Proof URL (optional)',
    proof_description: 'Description',
    describe_what_you_did: 'Describe what you did...',
    cancel: 'Cancel',
    submit: 'Submit',
    submitting: 'Submitting...',

    // Profile
    recent_submissions: 'Recent Submissions',
    no_submissions: 'No submissions yet',
    recent_transactions: 'Recent Transactions',
    no_transactions: 'No transactions yet',

    // Wallet
    available_balance: 'Available Balance',
    min_withdrawal: 'Min. withdrawal',
    eth_wallet_address: 'ETH Wallet Address',
    eth_wallet_desc: 'Enter your Ethereum wallet address to receive payouts',
    update_wallet: 'Update Wallet',
    updating: 'Updating...',
    set_wallet_to_withdraw: 'Set Wallet to Withdraw',
    need_min_to_withdraw: 'Need {amount} to Withdraw',
    withdraw: 'Withdraw',
    how_payouts_work: 'How Payouts Work',
    payout_step_1: '1. Complete tasks and get approved',
    payout_step_2: '2. Earnings are added to your balance',
    payout_step_3: '3. Withdraw when you reach {amount}',
    payout_step_4: '4. Receive ETH to your wallet (converted at market rate)',

    // Leaderboard
    tasks_completed: 'tasks completed',
    rep: 'Rep',
    you: 'You',

    // Platforms
    platform_reddit: 'Reddit',
    platform_google_maps: 'Google Maps',
    platform_instagram: 'Instagram',
    platform_twitter: 'Twitter/X',
    platform_app_store: 'App Store',
    platform_youtube: 'YouTube',
    platform_tiktok: 'TikTok',
    platform_other: 'Other',

    // Actions
    action_comment: 'Comment',
    action_review: 'Leave Review',
    action_follow: 'Follow',
    action_like: 'Like',
    action_share: 'Share',
    action_retweet: 'Retweet',
    action_subscribe: 'Subscribe',
    action_upvote: 'Upvote',
    action_post: 'Post',

    // Status
    status_approved: 'approved',
    status_rejected: 'rejected',
    status_pending: 'pending',
  },

  ar: {
    // Navigation
    nav_home: 'الرئيسية',
    nav_tasks: 'المهام',
    nav_top: 'الأعلى',
    nav_profile: 'الملف',

    // Home
    welcome: 'مرحبا',
    welcome_desc: 'أكمل المهام واكسب المكافآت',
    available_tasks: 'المهام المتاحة',
    view_all: 'عرض الكل',
    wallet: 'المحفظة',
    wallet_desc: 'ربط وسحب',
    leaderboard: 'المتصدرون',
    leaderboard_desc: 'أعلى الرابحين',

    // Stats
    balance: 'الرصيد',
    total_earned: 'إجمالي الأرباح',
    completed: 'مكتملة',
    pending: 'معلقة',
    reputation: 'السمعة',
    rank: 'الترتيب',
    tasks: 'مهام',
    reviews: 'مراجعات',

    // Tasks
    all: 'الكل',
    no_tasks_platform: 'لا توجد مهام متاحة لهذه المنصة',
    slots_left: 'متبقي',
    back: 'رجوع',
    claim_task: 'احجز المهمة',
    submit_proof: 'أرسل الإثبات',
    open_task_link: 'فتح رابط المهمة',
    no_slots: 'لا توجد أماكن متاحة',
    submission_status: 'حالة الإرسال',

    // Task details
    platform: 'المنصة',
    action: 'الإجراء',
    slots_available: 'الأماكن المتاحة',
    description: 'الوصف',
    instructions: 'التعليمات',
    proof_required: 'الإثبات المطلوب',
    deadline: 'الموعد النهائي',

    // Submit
    proof_url: 'رابط الإثبات (اختياري)',
    proof_description: 'الوصف',
    describe_what_you_did: 'صف ما فعلته...',
    cancel: 'إلغاء',
    submit: 'إرسال',
    submitting: 'جاري الإرسال...',

    // Profile
    recent_submissions: 'الإرسالات الأخيرة',
    no_submissions: 'لا توجد إرسالات بعد',
    recent_transactions: 'المعاملات الأخيرة',
    no_transactions: 'لا توجد معاملات بعد',

    // Wallet
    available_balance: 'الرصيد المتاح',
    min_withdrawal: 'الحد الأدنى للسحب',
    eth_wallet_address: 'عنوان محفظة ETH',
    eth_wallet_desc: 'أدخل عنوان محفظة إيثيريوم لاستلام المدفوعات',
    update_wallet: 'تحديث المحفظة',
    updating: 'جاري التحديث...',
    set_wallet_to_withdraw: 'عيّن المحفظة للسحب',
    need_min_to_withdraw: 'تحتاج {amount} للسحب',
    withdraw: 'سحب',
    how_payouts_work: 'كيف تعمل المدفوعات',
    payout_step_1: '1. أكمل المهام واحصل على الموافقة',
    payout_step_2: '2. تُضاف الأرباح إلى رصيدك',
    payout_step_3: '3. اسحب عند الوصول إلى {amount}',
    payout_step_4: '4. استلم ETH في محفظتك (بسعر السوق)',

    // Leaderboard
    tasks_completed: 'مهام مكتملة',
    rep: 'السمعة',
    you: 'أنت',

    // Platforms
    platform_reddit: 'ريديت',
    platform_google_maps: 'خرائط جوجل',
    platform_instagram: 'انستغرام',
    platform_twitter: 'تويتر/X',
    platform_app_store: 'متجر التطبيقات',
    platform_youtube: 'يوتيوب',
    platform_tiktok: 'تيك توك',
    platform_other: 'أخرى',

    // Actions
    action_comment: 'تعليق',
    action_review: 'ترك تقييم',
    action_follow: 'متابعة',
    action_like: 'إعجاب',
    action_share: 'مشاركة',
    action_retweet: 'إعادة تغريد',
    action_subscribe: 'اشتراك',
    action_upvote: 'تصويت',
    action_post: 'نشر',

    // Status
    status_approved: 'موافق عليه',
    status_rejected: 'مرفوض',
    status_pending: 'قيد الانتظار',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;

export function t(lang: Language, key: TranslationKey, vars?: Record<string, string | number>): string {
  let text: string = translations[lang]?.[key] || translations.en[key] || key;

  if (vars) {
    Object.entries(vars).forEach(([k, v]) => {
      text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }

  return text;
}

export function getUserLanguage(): Language {
  // Get from Telegram WebApp
  const tgLang = (window as any).Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  if (tgLang?.startsWith('ar')) return 'ar';

  // Fallback to browser
  if (navigator.language?.startsWith('ar')) return 'ar';

  return 'en';
}

export function isRTL(lang: Language): boolean {
  return lang === 'ar';
}
